import {
  Component,
  OnInit,
  Input,
  ViewChild,
  AfterViewInit,
  HostListener,
  ElementRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "./../../../shared/services";
import AOS from "aos";
import { EnvService } from "src/app/shared/services/env.service";
import {
  BreakpointObserver,
  BreakpointState,
  Breakpoints,
} from "@angular/cdk/layout";
import { Observable, Subscription } from "rxjs";
import { ChatService } from "src/app/shared/services/api/chat.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { ImageSearchDialogComponent } from "src/app/shared/components/image-search-dialog/image-search-dialog.component";

@Component({
  selector: "app-banner",
  templateUrl: "./banner.component.html",
  styleUrls: ["./banner.component.less"],
})
export class BannerComponent implements OnInit, AfterViewInit {
  bannerData: any[] = [];
  isBanner = true;
  banner = new Banner();
  @Input() isHandset = false;
  @Input() page = "home";
  brands: any[];
  featuredBrands: any[];
  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  bpSubscription: Subscription;
  email: string;

  EMAIL_REGEX =
    /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/g;
  invalidEmail: boolean;
  message: any;
  currentPage: string;
  blackSaleBanner: any[] = [];
  faqList: any[] = [
    {
      ques: "What can I expect from the Seeded design process?",
      ans: `With our Full Service design process, you will be paired with a professional interior designer to design your living space.
     Through the design process, you will receive:`,
      showAns: false,
    },
    {
      ques: "Why do I have to take a quiz to shop products at Seeded?",
      ans: `Our AI powered style quiz is designed to extract your personal 
  style tastes and generate your personalized shopping feed. 
  Once you have completed the quiz, all shopping lists on our site are curated to 
  rank products matching your style the highest.`,
      showAns: false,
    },
    {
      ques: "How much do your design services cost?",
      ans: `Our design service is offered completely complimentary without any fees 
  specifically associated to the design service.`,
      showAns: false,
    },
    {
      ques: "How do I get help with my furniture order after I have made a purchase?",
      ans: `Orders placed with Seeded are routed to sellers immediately and fulfilled directly 
  by the seller using in-house or outsourced logistics partners.
   Our concierge team monitors your orders throughout
   its journey and makes sure everything runs smoothly in the background.`,
      showAns: false,
    },
  ];
  isToggleChecked = false;
  @ViewChild("target", { static: false }) targetElement: any;
  query: any;
  promptSearchList: any[]=[];
  categoriesList:any[]=[];
  discoveryList:any[]=[];
  carouselKey: any;
  gallerySpotlight: any[]=[];
  productsList:any[]=[];
  pdNumVisibile = 4; 
  paramSku: any;
  loadDetails: boolean;
  public Math:Math= Math;
  carouselData: any[]=[];
  currentNumVisible: number = 3;
  productDetails: any;
  discountAvailable: boolean;
@ViewChild('scrollContainer') scrollContainerRef!: ElementRef;
  discountData: any;
  constructor(
    private apiService: ApiService,
    private dialog:MatDialog,
    private router: Router,
    public env: EnvService,
    public chatService: ChatService,
    private snackBar:MatSnackBar,
    private breakpointObserver: BreakpointObserver
  ) {
    this.bpSubscription = this.bpObserver.subscribe(
      (handset: BreakpointState) => {
        this.isHandset = handset.matches;
      }
    );
    this.currentPage = location.pathname;
    this.pdNumVisibile = window.innerWidth < 1400 ? 3:4;

  }
  get elementHeight(): any {
    if (this.targetElement && this.targetElement.nativeElement) {
      const height = this.targetElement.nativeElement.offsetHeight;
      return { height: height + "px" };
    }
    return { height: "auto" };
  }

  get height():number{
    return (window.innerHeight<836 && this.discoveryList?.length>0) ? 836: window.innerHeight - 60;
  }
    @HostListener('window:resize', ['$event'])
    onResize(event) {
       this.pdNumVisibile = window.innerWidth < 1400 ? 3:4;
       this.getNumVisible();
    }
  ngOnInit() {
    this.getDiscountData();
    this.designGallerySpotlight();
    this.getDesingerProfile();
    sessionStorage.removeItem('promptCategory'); 
    this.chatService.productsDataPLP = [];
    this.chatService.promptCategory='';
    AOS.init();

    if(this.chatService.promptSearchList && this.chatService.promptSearchList.length>0){
      this.promptSearchList =this.chatService.promptSearchList;
      this.categoriesList = this.chatService.categoriesList;
      this.discoveryList = this.chatService.discoveryList;
      this.carouselKey = this.chatService.carouselKey;
     this.carouselData=  this.chatService.carouselData ;

    } else {
      this.getPromptsSearch();

    }

    if (
      location.href.includes(this.env.siteUrl) ||
      location.href.includes("localhost")
    ) {
      this.banner.image =
        this.env.assetBaseUrl + "site/banners/test/landing-d-light.jpeg";
    } else {
      this.banner.image =
        this.env.assetBaseUrl + "site/banners/landing-d-light.jpeg";
    }
    if (this.page === "shop" || this.currentPage === "/") {
      this.apiService.bannerData().subscribe((res: any[]) => {
        this.bannerData = res.filter((value) => value.position === "primary");
        this.blackSaleBanner = res.filter((value) => value.position === "hero");
        this.apiService.blackSaleBanner = this.blackSaleBanner;
      });
    }

  } 

  designers: any[] = [];
  getDesingerProfile() {
    this.apiService.getDesignProfile().subscribe(res => {
      if (res[0]) {
        res.forEach(d => {
          d.imageLoaded = false
        });
      this.designers = res.sort(() => Math.random() - 0.5);
        setTimeout(() => {
          const container = this.scrollContainerRef?.nativeElement; 
          container?.addEventListener('scroll', () => {
            if (container.scrollLeft > 10) {
              container.classList.add('scrolled');
            } else {
              container.classList.remove('scrolled');
            }
          });
        }, 2000);
      }
    })
  }
    onImageLoad(item: any) {
    item.imageLoaded = true;
  }

  goToDesignerProfile(designer){
        this.router.navigate([]).then(() => {
        window.open(`/design/${designer.designerId}`, "_blank");
      }); 
  }
    openInsta(designer) {
    window.open(designer.social_ig, '_blank');
  }
  designGallerySpotlight(){
    this.apiService.designGallerySpotlight().subscribe((res:any[])=>{
      this.gallerySpotlight = res.sort((a,b)=> a.rank - b.rank) // res.sort(() => Math.random() - 0.5);
    })
  }

    getDiscountData(){
    this.apiService.getDiscountData().subscribe((res:any)=>{
      if(res){
        if(res.display_discount){
          this.discountAvailable = true;
        }
        this.discountData = res;  
        this.discountData['display_discount_before_conv'] = res.display_discount;
        this.discountData['display_discount'] = Math.round(this.discountData['display_discount']);
      }
    })
  }
    get getDiscountAmount(){
    let discount =  ((+this.discountData.design_book_amount) * (1 - ((+this.discountData.display_discount_before_conv)/100)));
    return Math.round(+discount);
  }
  get envirnoment(): boolean {
    return (
      location.href.includes(this.env.siteUrl) ||
      location.href.includes("localhost")
    );
  }
  ngAfterViewInit(): void {

    setTimeout(() => {
      // this.getbrands();
      // this.getPromptsSearch();
    }, 2500);
    document.addEventListener("DOMContentLoaded", function() {
      const textarea = document.getElementById("chatInput");
  
      textarea.addEventListener("input", function() {
          this.style.height = "auto";
          this.style.height = (this.scrollHeight - 20) + "px";
      });
  });


  }
  getbrands() {
    this.apiService.getBrands().subscribe((res: any) => {
      this.brands = res;
      this.brands = this.brands.filter((val) => {
        if (val.value !== "potterybarn") {
          return val;
        }
      });
      this.featuredBrands = this.brands.filter((_) => _.is_home_feature === 1);
    });
  }
  routeToSale() {
    // this.router.navigate(['/products/all'], { queryParams: { sale: true } });
    this.router.navigate(["/products/sale/cyber-week"]);
  }
  navTo(url) {
    window.open(url, "_self");
  }
  submit(data) {
    if (this.EMAIL_REGEX.test(data)) {
      this.invalidEmail = false;
      const url = window.location.href.split("?")[0];
      this.apiService.subscription(url, data).subscribe((response: any) => {
        this.message = response.message;
        if (!response.subscribed) {
          this.apiService
            .newsLetterSubmit(this.email)
            .subscribe((response: any) => {});
        }
        // if (payload.status === 'We already have your email. Thanks!') {
        //   this.subscriberExists = true;
        // } else if (payload.status === 'success') {
        //   this.showSuccessMsg = true;
        // }
      });
    } else {
      this.invalidEmail = true;
    }
  }
  goToQuiz() {
    this.router.navigate(["/style-quiz"]);
  }
  goToAppointments() {
    this.router.navigate(["/design"]);
  }

  getPromptsSearch(){
    this.chatService.getPromptSearch().subscribe((resp:any[])=>{
      this.promptSearchList = resp.find(f=>f.type==='primary')?.prompt_details;
      this.categoriesList = resp.find(f=>f.type==='secondary')?.prompt_details;
      this.discoveryList = resp.find(f=>f.type==='discover')?.prompt_details;
      this.carouselData = resp.find(f=>f.type==='discover')?.prompt_details?.filter(n=>n.display_carousel==1
      );
     
      if(this.carouselData?.length){
        for(let i=0;i<this.carouselData.length;i++){
          this.apiService.getProducts(this.carouselData[i].category, "", "", "", 0).subscribe((res:any)=>{ 
            if(res.products && res.products.length>0 ){
            this.carouselData[i]['productsList'] = res.products;
            this.carouselData[i]['productsList'].forEach((element) => {
              if (element.percent_discount) {
                element.percent_discount = parseInt(element.percent_discount) ;
              } 
            });
            // this.carouselData =  this.carouselData.filter(f=>f.productsList.length>0);
          //  this.chatService.carouselData = this.carouselData.filter(f=>f.productsList.length>0);
            } else {
              // this.carouselData[i]['productsList'] = [];
              // this.carouselData = this.carouselData.filter(f=>f.productsList && f.productsList.length>0);
              //      this.chatService.carouselData = this.carouselData.filter(f=>f.productsList && 
              //       f.productsList.length>0);   
                  }
                  this.chatService.carouselData = this.carouselData

          })
        }
     
      }

    })
  }
  assignQuery() {
    this.apiService.imgSearchData = null;
    this.query = this.query.replace(/\n/g, '');
    sessionStorage.removeItem('promptCategory'); 
    sessionStorage.removeItem('promptType'); 

    this.chatService.productsDataPLP = [];
    this.chatService.promptCategory='';
    this.chatService.promptType = '';

    this.chatService.productsDataPLP = this.chatService.loaderData;
    if (this.isToggleChecked) { 
      this.chatService.query = this.query;
      this.router.navigate(["/chat"]);
    } else {  
      this.router.navigate(['/search'], {
  queryParams: { query: this.query }
}).then(() => {
  this.query = '';
});

    }
  }

  goToCategory(data,type:string){  
    localStorage.removeItem('recentChat');
    this.chatService.productsDataPLP = this.chatService.loaderData;
    this.chatService.query = data.query; 
    this.chatService.promptCategory = data.category;
    this.chatService.promptType = type;
    sessionStorage.setItem('promptType',this.chatService.promptType);
    sessionStorage.setItem('promptCategory',this.chatService.promptCategory);
    if(type==='discover'){
      if(this.isToggleChecked){
      this.router.navigate(['/c'], {
        queryParams: {
          query: this.chatService.promptCategory,
          type: type
        }
      });
    }else {  
            this.router.navigate(['/search'], {
  queryParams: { query: this.chatService.query }
}).then(() => {
  this.query = '';
});
    }
    } else {
      this.router.navigate(['/chat'], {
        queryParams: {
          type: type
        }
      });
    }
  }
  openProductNav(data) {
    this.paramSku = data.sku;
    this.productDetails = data;
    this.loadDetails = true;
    document.getElementById("productSidenav").style.width = "450px";
      document.getElementById('productSidenav').scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    // this.api.isSideNavOpened = true;
  }

  getNumVisible(): number {
    if (this.gallerySpotlight && this.gallerySpotlight.length > 0) {
    if(window.innerWidth < 768) {
         return Math.min(1, this.gallerySpotlight.length);
    }
    if(window.innerWidth < 1400) {
         return Math.min(2, this.gallerySpotlight.length);
    }
      return Math.min(3, this.gallerySpotlight.length);
   } // Default to 3 for larger screens
  }

  closeProductNav(msg) {
    if (document.getElementById("productSidenav")) {
      this.loadDetails = false;
      document.getElementById("productSidenav").style.width = "0";
      document.body.style.backgroundColor = "white";
      if(msg!=='close' && msg){
        this.snackBar.open(msg, 'x', { duration: 3000 })
      } 
    }
  } 
  openImageDialog(){
    this.dialog.open(ImageSearchDialogComponent,{
      width:'700px',
      panelClass:'image-search-dialog'
    })
  }
}
export class Banner {
  "name": string;
  "image": string;
  "link": string;
  "link_label": string;
  "banner_label": string;
  "font_hex": string;
  "position": string;
  "rank": number;
  "link_type": string;
}
